package ui.eReceipt.components

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.Row
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.width
import androidx.compose.foundation.layout.widthIn
import androidx.compose.foundation.shape.CutCornerShape
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.graphicsLayer
import androidx.compose.ui.unit.Dp
import androidx.compose.ui.unit.dp

@Composable
private fun PerforatedEdge(
    perfWidth: Dp = 20.dp,
    perfHeight: Dp = 20.dp,
    color: Color = Color.White,
    isTopPosition: Boolean = true,
    maxWidth: Dp,
    timesToRepeat: Int = 40
) {
    val perfSideWidth = perfWidth / 2

    val modifier: Modifier = Modifier.widthIn(0.dp, maxWidth)
    Row(
        modifier = modifier,
        verticalAlignment = Alignment.Bottom
    ) {
        repeat(timesToRepeat) {
            Box(
                modifier = Modifier
                    .graphicsLayer {
                        if (!isTopPosition)
                            rotationX = 180f
                    }
                    .height(perfHeight)
                    .width(perfWidth)
                    .clip(CutCornerShape(topStart = perfSideWidth, topEnd = perfSideWidth))
                    .background(color)
            )
        }
    }
}

@Composable
fun PerforatedEdgeContainer(
    maxWidth: Dp,
    content: @Composable () -> Unit
){
    PerforatedEdge(
        maxWidth = maxWidth
    )
    content()
    PerforatedEdge(
        isTopPosition = false,
        maxWidth = maxWidth
    )
}
